// extracted by mini-css-extract-plugin
module.exports = {"Banner":"admin-portal__Pharmacists__Banner","BannerButton":"admin-portal__Pharmacists__BannerButton"};